import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {CustomScrollbarModule} from '../../components/custom-scrollbar';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {L10nModule} from '../../components/translate';
import {TextHidingModule} from '../../directives/text-hiding';
import {EMPTY_WIDGET_DESCRIPTION} from './empty-widget-description';
import {EmptyWidgetComponent} from './empty-widget.component';
import {EmptyWidgetSettingsService} from './settings';

@NgModule({
    imports: [
        CommonModule,
        CustomScrollbarModule,
        L10nModule,
        TextHidingModule
    ],
    declarations: [
        EmptyWidgetComponent
    ],
    exports: [
        EmptyWidgetComponent
    ],
    providers: [
        EmptyWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: EMPTY_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class EmptyWidgetModule {}
